/* eslint-disable */
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PrintIcon from "@material-ui/icons/Print";
import CloseIcon from "@material-ui/icons/Close";
import hospitalLogo from "assets/img/logo2.png";
import moment from "moment";
import "moment/locale/th";

moment.locale("th");

const formatThaiDateTime = dt => {
  if (!dt) return "-";
  const m = moment(dt);
  if (!m.isValid()) return "-";
  const thaiYear2Digit = (m.year() + 543).toString().slice(-2);
  return `${m.format("D MMM")} ${thaiYear2Digit} ${m.format("HH:mm")} น.`;
};

const useStyles = makeStyles(theme => ({
  dialogPaper: {
    width: "100%",
    maxWidth: "230mm",
    margin: "16px auto",
    "@media print": {
      width: "100% !important",
      maxWidth: "100% !important",
      margin: "0 !important",
      boxShadow: "none !important",
      border: "none !important",
      borderRadius: "0 !important"
    }
  },
  dialogContent: {
    padding: "20px 24px",
    backgroundColor: "#ffffff",
    "@media print": {
      padding: "0 !important",
      overflow: "visible !important"
    }
  },
  printContainer: {
    fontFamily: '"Sarabun", "TH Sarabun New", "Tahoma", sans-serif',
    color: "#0f172a",
    fontSize: "14px",
    lineHeight: 1.4,
    "@media print": {
      fontSize: "12pt",
      lineHeight: 1.3
    }
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    paddingBottom: 12,
    marginBottom: 16,
    borderBottom: "2px solid #0f172a"
  },
  logo: {
    position: "absolute",
    left: 0,
    top: "50%",
    transform: "translateY(-50%)",
    width: 60,
    height: 60,
    objectFit: "contain",
    "@media print": {
      width: "16mm",
      height: "16mm"
    }
  },
  headerTextContainer: {
    textAlign: "center"
  },
  hospitalName: {
    fontWeight: "bold",
    fontSize: "18px",
    color: "#0f172a",
    margin: 0,
    "@media print": {
      fontSize: "16pt"
    }
  },
  reportTitle: {
    fontWeight: "bold",
    fontSize: "16px",
    color: "#1e293b",
    margin: "4px 0 0 0",
    "@media print": {
      fontSize: "14pt"
    }
  },
  reportSubTitle: {
    fontSize: "14px",
    color: "#475569",
    marginTop: 4,
    "@media print": {
      fontSize: "12pt"
    }
  },
  metaInfo: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
    fontSize: "13px",
    color: "#334155",
    "@media print": {
      fontSize: "11pt"
    }
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: 16,
    "& th, & td": {
      border: "1px solid #cbd5e1",
      padding: "8px 10px",
      fontSize: "13px",
      "@media print": {
        border: "1px solid #000000",
        padding: "6px 8px",
        fontSize: "11pt"
      }
    },
    "& th": {
      backgroundColor: "#f1f5f9",
      fontWeight: "bold",
      color: "#0f172a",
      textAlign: "center",
      "@media print": {
        backgroundColor: "#e2e8f0 !important",
        WebkitPrintColorAdjust: "exact",
        printColorAdjust: "exact"
      }
    }
  },
  textCenter: {
    textAlign: "center"
  },
  textRight: {
    textAlign: "right"
  },
  totalRow: {
    fontWeight: "bold",
    backgroundColor: "#f8fafc",
    "@media print": {
      backgroundColor: "#f1f5f9 !important",
      WebkitPrintColorAdjust: "exact",
      printColorAdjust: "exact"
    }
  },
  signSection: {
    marginTop: 32,
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 24,
    breakInside: "avoid",
    pageBreakInside: "avoid",
    "@media print": {
      marginTop: "20mm"
    }
  },
  signBox: {
    textAlign: "center",
    fontSize: "13px",
    "& .dotLine": {
      marginTop: 40,
      borderBottom: "1px dotted #64748b",
      width: "180px",
      margin: "0 auto 6px auto",
      "@media print": {
        borderBottom: "1px dotted #000000"
      }
    }
  },
  noPrint: {
    "@media print": {
      display: "none !important"
    }
  }
}));

export default function BeamPaymentReportPrintDialog({
  open,
  onClose,
  data = [],
  filter = {},
  summary = {},
  currentUser = null
}) {
  const classes = useStyles();

  const handlePrint = () => {
    window.print();
  };

  // จัดรูปแบบข้อความช่วงวันที่สำหรับหัวรายงาน
  const getFilterDisplay = () => {
    const type = filter.filterType || "day";
    if (type === "day" && filter.date) {
      const m = moment(filter.date);
      const yearTh = m.year() > 2500 ? m.year() : m.year() + 543;
      return `ประจำวันที่ ${m.format("D MMMM")} พ.ศ. ${yearTh}`;
    }
    if (type === "month" && filter.month && filter.year) {
      const yearTh = filter.year > 2500 ? filter.year : filter.year + 543;
      const monthName = moment().month(filter.month - 1).format("MMMM");
      return `ประจำเดือน ${monthName} พ.ศ. ${yearTh}`;
    }
    if (type === "range") {
      const s = filter.startDate ? moment(filter.startDate) : null;
      const e = filter.endDate ? moment(filter.endDate) : null;
      const sStr = s ? `${s.format("D MMM")} ${s.year() > 2500 ? s.year() : s.year() + 543}` : "-";
      const eStr = e ? `${e.format("D MMM")} ${e.year() > 2500 ? e.year() : e.year() + 543}` : "-";
      return `ช่วงวันที่ ${sStr} ถึง ${eStr}`;
    }
    return `ข้อมูล ณ วันที่ ${moment().format("D MMMM")} พ.ศ. ${moment().year() + 543}`;
  };

  const printTimeFormatted = moment().format("D MMMM YYYY เวลา HH:mm น.");
  const printerName = currentUser?.fullName || currentUser?.name || currentUser?.userName || "เจ้าหน้าที่การเงิน";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      classes={{ paper: classes.dialogPaper }}
    >
      {/* Global CSS สำหรับการสั่งพิมพ์ */}
      <style>{`
        @media print {
          body * {
            visibility: hidden;
          }
          #beam-print-area, #beam-print-area * {
            visibility: visible;
          }
          #beam-print-area {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
          }
          .MuiDialog-container {
            display: block !important;
            padding: 0 !important;
          }
          .MuiPaper-root {
            box-shadow: none !important;
            border: none !important;
          }
          @page {
            size: A4 portrait;
            margin: 12mm 10mm 12mm 10mm;
          }
        }
      `}</style>

      <DialogTitle className={classes.noPrint}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" style={{ fontWeight: "bold" }}>
            ตัวอย่างก่อนพิมพ์ (Print Preview) - รายงานการชำระเงิน BEAM
          </Typography>
          <Button
            size="small"
            onClick={onClose}
            startIcon={<CloseIcon />}
            variant="outlined"
          >
            ปิด
          </Button>
        </Box>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <div id="beam-print-area" className={classes.printContainer}>
          {/* Header */}
          <div className={classes.header}>
            <img src={hospitalLogo} alt="Logo" className={classes.logo} />
            <div className={classes.headerTextContainer}>
              <div className={classes.hospitalName}>
                โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง
              </div>
              <div className={classes.reportTitle}>
                รายงานธุรกรรมการชำระเงินผ่านระบบ BEAM Checkout
              </div>
              <div className={classes.reportSubTitle}>
                {getFilterDisplay()}
                {filter.filterKioskOnly !== false && " (เฉพาะ Kiosk)"}
                {filter.transactionType && filter.transactionType !== "ALL" && ` [ประเภท: ${filter.transactionType}]`}
              </div>
            </div>
          </div>

          {/* Meta Info */}
          <div className={classes.metaInfo}>
            <div>
              <span>จำนวนรายการทั้งหมด: <strong>{data.length}</strong> รายการ</span>
            </div>
            <div>
              <span>วันที่พิมพ์: {printTimeFormatted}</span>
            </div>
          </div>

          {/* Data Table */}
          <table className={classes.table}>
            <thead>
              <tr>
                <th style={{ width: "35px" }}>ลำดับ</th>
                <th style={{ width: "160px" }}>Transaction ID</th>
                <th style={{ width: "75px" }}>HN (Kiosk)</th>
                <th style={{ width: "95px" }}>เลขที่ใบเสร็จ</th>
                <th style={{ width: "90px" }}>เล่มที่/เลขที่</th>
                <th style={{ width: "135px" }}>วัน-เวลาที่ทำรายการ</th>
                <th style={{ width: "90px" }}>ยอดสุทธิ (บาท)</th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan="7" className={classes.textCenter} style={{ padding: "20px" }}>
                    ไม่พบข้อมูลธุรกรรมตามเงื่อนไขที่เลือก
                  </td>
                </tr>
              ) : (
                data.map((item, index) => (
                  <tr key={item.transactionId || index}>
                    <td className={classes.textCenter}>{index + 1}</td>
                    <td>
                      <div style={{ fontWeight: "bold", fontSize: "12px", color: "#0f172a" }}>
                        {item.fullName || "-"}
                      </div>
                      <div style={{ fontFamily: "monospace", fontSize: "10px", color: "#64748b" }}>
                        {item.transactionId}
                      </div>
                    </td>
                    <td className={classes.textCenter} style={{ fontWeight: "bold" }}>
                      {item.hn || "-"}
                    </td>
                    <td className={classes.textCenter}>
                      {item.receiptNo || "-"}
                    </td>
                    <td className={classes.textCenter}>
                      {item.docNum || "-"}
                    </td>
                    <td className={classes.textCenter} style={{ fontSize: "11px" }}>
                      {formatThaiDateTime(item.transactionTime)}
                    </td>
                    <td className={classes.textRight} style={{ fontWeight: "bold" }}>
                      {Number(item.netAmountBaht || 0).toLocaleString("th-TH", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </td>
                  </tr>
                ))
              )}
              {data.length > 0 && (
                <tr className={classes.totalRow}>
                  <td colSpan="6" className={classes.textRight}>
                    รวมยอดเงินสุทธิทั้งสิ้น ({data.length} รายการ):
                  </td>
                  <td className={classes.textRight}>
                    {Number(summary.totalNetAmountBaht || 0).toLocaleString("th-TH", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Signature Section */}
          <div className={classes.signSection}>
            <div className={classes.signBox}>
              <div>ผู้จัดทำรายงาน</div>
              <div className="dotLine" />
              <div>( {printerName} )</div>
              <div style={{ marginTop: 4, color: "#64748b" }}>วันที่ ......./......./..........</div>
            </div>
            <div className={classes.signBox}>
              <div>ผู้ตรวจสอบ</div>
              <div className="dotLine" />
              <div>( ................................................................ )</div>
              <div style={{ marginTop: 4, color: "#64748b" }}>วันที่ ......./......./..........</div>
            </div>
          </div>
        </div>
      </DialogContent>

      <DialogActions className={classes.noPrint} style={{ padding: "12px 24px" }}>
        <Button onClick={onClose} variant="outlined" color="default">
          ปิด
        </Button>
        <Button
          onClick={handlePrint}
          variant="contained"
          color="primary"
          startIcon={<PrintIcon />}
          style={{ backgroundColor: "#2563eb", color: "#fff" }}
        >
          พิมพ์ (Print)
        </Button>
      </DialogActions>
    </Dialog>
  );
}

